"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var removeEmptyObjects = function removeEmptyObjects(obj) {
    if ((0, _keys2.default)(obj).length === 0) {
        return obj;
    }
    for (var key in obj) {
        if (obj.hasOwnProperty(key) && (0, _typeof3.default)(obj[key]) === "object" && !Array.isArray(obj[key])) {
            obj[key] = removeEmptyObjects(obj[key]);
            if ((0, _keys2.default)(obj[key]).length === 0) {
                delete obj[key];
            }
        }
    }
    return obj;
};

exports.default = removeEmptyObjects;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvdXRpbHMvcmVtb3ZlRW1wdHlPYmplY3RzLmpzeCJdLCJuYW1lcyI6WyJyZW1vdmVFbXB0eU9iamVjdHMiLCJvYmoiLCJsZW5ndGgiLCJrZXkiLCJoYXNPd25Qcm9wZXJ0eSIsIkFycmF5IiwiaXNBcnJheSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLElBQU1BLHFCQUFxQixTQUFyQkEsa0JBQXFCLENBQUNDLEdBQUQsRUFBUztBQUNoQyxRQUFJLG9CQUFZQSxHQUFaLEVBQWlCQyxNQUFqQixLQUE0QixDQUFoQyxFQUFtQztBQUMvQixlQUFPRCxHQUFQO0FBQ0g7QUFDRCxTQUFLLElBQUlFLEdBQVQsSUFBZ0JGLEdBQWhCLEVBQXFCO0FBQ2pCLFlBQUlBLElBQUlHLGNBQUosQ0FBbUJELEdBQW5CLEtBQTJCLHNCQUFPRixJQUFJRSxHQUFKLENBQVAsTUFBb0IsUUFBL0MsSUFBMkQsQ0FBQ0UsTUFBTUMsT0FBTixDQUFjTCxJQUFJRSxHQUFKLENBQWQsQ0FBaEUsRUFBeUY7QUFDckZGLGdCQUFJRSxHQUFKLElBQVdILG1CQUFtQkMsSUFBSUUsR0FBSixDQUFuQixDQUFYO0FBQ0EsZ0JBQUksb0JBQVlGLElBQUlFLEdBQUosQ0FBWixFQUFzQkQsTUFBdEIsS0FBaUMsQ0FBckMsRUFBd0M7QUFDcEMsdUJBQU9ELElBQUlFLEdBQUosQ0FBUDtBQUNIO0FBQ0o7QUFDSjtBQUNELFdBQU9GLEdBQVA7QUFDSCxDQWJEOztrQkFlZUQsa0IiLCJmaWxlIjoicmVtb3ZlRW1wdHlPYmplY3RzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgcmVtb3ZlRW1wdHlPYmplY3RzID0gKG9iaikgPT4ge1xuICAgIGlmIChPYmplY3Qua2V5cyhvYmopLmxlbmd0aCA9PT0gMCkge1xuICAgICAgICByZXR1cm4gb2JqO1xuICAgIH1cbiAgICBmb3IgKGxldCBrZXkgaW4gb2JqKSB7XG4gICAgICAgIGlmIChvYmouaGFzT3duUHJvcGVydHkoa2V5KSAmJiB0eXBlb2Ygb2JqW2tleV0gPT09IFwib2JqZWN0XCIgJiYgIUFycmF5LmlzQXJyYXkob2JqW2tleV0pKSB7XG4gICAgICAgICAgICBvYmpba2V5XSA9IHJlbW92ZUVtcHR5T2JqZWN0cyhvYmpba2V5XSk7XG4gICAgICAgICAgICBpZiAoT2JqZWN0LmtleXMob2JqW2tleV0pLmxlbmd0aCA9PT0gMCkge1xuICAgICAgICAgICAgICAgIGRlbGV0ZSBvYmpba2V5XTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgIH1cbiAgICByZXR1cm4gb2JqO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgcmVtb3ZlRW1wdHlPYmplY3RzO1xuIl19